
const GroupId = (state) => state.GroupId;
const Group = (state) => state.Group;
const Groups = (state) => state.Groups;
const TotalInfo = (state) => state.TotalInfo;
export default { GroupId, Group, TotalInfo, Groups }